import React from 'react';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';

interface DayActionsToolbarProps {
  isEditMode: boolean;
  selectedDay: string | null;
  onEditModeToggle: () => void;
  onAddPOI: (day: number) => void;
}

function DayActionsToolbar({
  isEditMode,
  selectedDay,
  onEditModeToggle,
  onAddPOI,
}: DayActionsToolbarProps) {
  return (
    <>
      <Button
        variant={isEditMode ? 'contained' : 'outlined'}
        size="small"
        startIcon={<EditIcon />}
        onClick={onEditModeToggle}
      >
        {isEditMode ? 'Done Editing' : 'Edit Trip'}
      </Button>
      {selectedDay && (
        <Button
          variant="outlined"
          size="small"
          startIcon={<AddIcon />}
          onClick={() => onAddPOI(parseInt(selectedDay))}
        >
          Add POI
        </Button>
      )}
    </>
  );
}

export default DayActionsToolbar;
